<template>
  <div
    class="bd-cell"
    :class="{
      active: index + 1 == activeRowIndex,
    }"
  >
    <bd-cell-item v-for="(item, index) in list" :key="index" :item="item" />
    <div v-if="discount && !stopHd" class="discount-box"></div>
  </div>
</template>
<script>
import BdCellItem from './bd-cell-item'

export default {
  name: 'bd-cell',
  props: ['list', 'index', 'activeRowIndex', 'stopHd'],
  components: {
    BdCellItem,
  },
  data() {
    return {
      discount: false,
    }
  },
  mounted() {
    if (
      this.$route.path == '/tariff/exam' &&
      this.index == 0 &&
      !this.$store.state.app.device
    ) {
      this.discount = true
    }
  },
}
</script>
<style lang="scss" scoped>
.bd-cell {
  &:hover,
  &.active {
    box-shadow: 0px 5px 15px 0px #999999 !important;
    z-index: 100;
    background: #fff;
  }
  &.activeRowIndex {
    box-shadow: -8px 4px 15px #edf5f5;
  }
  position: relative;
  box-shadow: -8px 4px 15px #edf5f5;
  .discount-box {
    height: 160px;
    width: 160px;
    position: absolute;
    top: 34px;
    left: 20px;
    opacity: 0.8;
    background: url('~@/static/images/sale2.png') no-repeat center;
  }
}
@media screen and (max-width: 600px) {
  .bd-cell {
    .discount-box {
      width: 100%;
      background-size: contain;
      height: 200px;
      margin: 0px -20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/bd-cell/index.vue